<template>
  <SfStaticPill :variant="variant">
    <i
      v-if="icon"
      :class="[
        'fa-solid',
        `fa-${icon}`,
        'tw-flex tw-size-3 tw-items-center tw-justify-center tw-text-[10px]',
      ]"
      aria-hidden="true"
      data-testid="sf-static-pill-icon"
    />
    {{ label }}
  </SfStaticPill>
</template>

<script setup lang="ts">
import SfStaticPill from '@app/shared/vue/components/sf-static-pill/sf-static-pill.vue'
import { staticPillVariants } from '@app/shared/vue/components/sf-static-pill/constants'
import type { StaticPillVariant } from '@app/shared/vue/components/sf-static-pill/constants'

defineOptions({ name: 'SfCeStaticPill' })

interface Props {
  label: string
  variant?: StaticPillVariant
  icon?: string
}

withDefaults(defineProps<Props>(), {
  variant: staticPillVariants.NEUTRAL,
  icon: undefined,
})
</script>
